import { handle } from 'redux-pack';

import { Action } from "../../../types/actions";
import {
	BrandliveEvent,
	Color,
	CreateEventRequest,
	FontPack,
	Template,
	Session,
	PageModule,
	Requirement,
	CreateSession,
	GateTypes,
	RegistrationStepType,
	PrivacyPolicy,
	TermsConditions,
	RegistrationStep,
	EPreviewTypes,
	SelectedBrandliveEvent,
	NavMainItems,
	CustomPage,
	SessionTypesEnum,
	GlobalCurrency,
	IScheduledEmail,
	IEventTag,
	ChannelCustomizedIcon,
	ICreateAccordion,
	LoadingStatus,
	GetEventsResponse,
} from "../../../types/working-model";
import {
	ADD_NEW_COLOR_PACK,
	ADD_NEW_FONT_PACK,
	ADD_NEW_SESSION,
	ADD_REGISTRATION_REQUIREMENT,
	CREATE_NEW_EVENT,
	CREATE_NEW_SESSION,
	LOAD_COLOR_PACKS,
	LOAD_FONT_PACKS,
	LOAD_TEMPLATES,
	LOAD_WORKING_EVENT,
	SAVE_COLOR_PACK,
	SET_CUSTOM_CSS,
	SET_DESIGN_SHAPE,
	SET_DESIGN_STYLE,
	SET_EVENT_NAME,
	SET_REGISTRATION_FEATURE,
	SET_CUSTOM_PASSCODE_LABEL,
	SET_REGISTRATION_ON,
	SET_REGISTRATION_QUESTIONS,
	SET_REGISTRATION_TYPE,
	SET_SELECTED_COLOR,
	SET_SELECTED_FONT,
	SET_WORKING_EVENT,
	TOGGLE_AUTOMATIC_SESSION_FILTER_BY_USER_LANGUAGE,
	TOGGLE_REGISTRATION_QUESTION_REQUIRED,
	TOGGLE_HOMEPAGE_MODULE,
	UPDATE_HOMEPAGE_MODULE,
	UPDATE_HOMEPAGE_HEADER,
	UPDATE_HOMEPAGE_FOOTER,
	UPDATE_HOMEPAGE_MAIN_NAV,
	UPDATE_HOMEPAGE_PROFILE_NAV,
	UPDATE_POST_REGISTER_HOME_MODULES,
	SET_HOMEPAGE_MODULES,
	ADD_PAGE_MODULE,
	ADD_POST_REGISTER_HOME_PAGE_MODULE,
	CLEAR_WORKING_EVENT,
	SET_REGISTRATION_HEADER,
	SET_REGISTRATION_DESCRIPTION,
	SET_REGISTRATION_IMAGE,
	SET_REGISTRATION_LOGO,
	REMOVE_REGISTRATION_REQUIREMENT,
	UPDATE_REGISTRATION_REQUIREMENT,
	SET_BLOCKED_DOMAIN_EMAILS,
	DELETE_SESSION,
	REMOVE_SESSION,
	UPDATE_SESSION_INFO,
	UPDATE_SESSION_CARD,
	REMOVE_IN_CREATION_PROGRESS_SESSION,
	EDIT_SESSION_AGENDA,
	UPDATE_EDITING_SESSION_BY_UID,
	CLEAR_NEW_EVENT_REQUEST,
	UPDATE_WORKING_EVENT,
	MODULE_LAYOUT_UPDATE,
	DUPLICATE_SESSION,
	IS_SAVING,
	SET_AGENDA_IMAGE,
	DELETE_FONT_PACKS,
	DELETE_COLOR_PACKS,
	PUBLISH_EVENT,
	SET_REGISTRATION_SINGLE_SIGN_ON,
	CHECK_REGISTRATION_SINGLE_SIGN_ON,
	SET_REGISTRATION_SINGLE_SIGN_ON_TYPES,
	CHOOSE_REGISTRATION_STEP,
	UPDATE_REGISTRATION_STEPS,
	UPDATE_REGISTRATION_SETTINGS,
	UPDATE_ALL_EVENT_SESSIONS_OVERLAY_CHAT,
	UPDATE_WORKING_EVENT_SESSION,
	UPDATE_ALL_EVENT_SESSIONS_LAYOUT_TABS,
	SET_DESIGN_COLORS,
	TOGGLE_POST_REGISTER_HOME_MODULE,
	ADD_REGISTRATION_STEP,
	ADD_TICKETING_SET,
	UPDATE_TICKETING_SET,
	REMOVE_TICKETING_SET,
	SET_SELECTED_EVENT,
	CLEAR_SELECTED_EVENT,
	SET_EDITOR_SIZE,
	TOGGLE_PREVIEW_MODE,
	ADD_WORKING_EVENT_HOMEPAGE,
	SET_EVENT_CUSTOM_CSS,
	UPDATE_REQUIRED_REGISTRATION_QUESTIONS,
	SET_SOCIAL_SHARING,
	GET_PUBLISHED_EVENT_URL,
	CLEAR_PUBLISHED_URL,
	UPDATE_PUBLISHED_EVENT_URL,
	UPDATE_EVENT_FAVICON,
	DELETE_EVENT_FAVICON,
	REMOVE_EVENT,
	ADD_NEW_SESSION_TO_STORE,
	ADD_HOMEPAGE_TO_WORKING_EVENT,
	TOGGLE_CUSTOMIZE_FORM_MODAL,
	loadWorkingEvent,
	isSavingEvent,
	UPDATE_CURRENT_POST_REGISTER_PAGE,
	BLUR_EDITOR,
	UPDATE_EMAIL_COLOR,
	TOGGLE_EMAIL_SETTINGS_HIDE_BRANDING,
	UPDATE_EVENT_NAVBAR,
	SET_REGISTRATION_SSO_DISPLAY_TOP,
	ADD_CUSTOM_PAGE,
	UPDATE_CUSTOM_PAGES,
	UPDATE_CUSTOM_PAGE,
	TOGGLE_CUSTOM_PAGE_MODULE,
	UPDATE_CUSTOM_PAGE_MODULE,
	DELETE_CUSTOM_PAGE,
	SET_ADD_MODULE_MODAL_OPEN,
	TOGGLE_DISPLAY_SESSION_FOOTER,
	TOGGLE_DISPLAY_SESSIONS,
	SET_SOCIAL_SETTINGS,
	SET_SOCIAL_IN_STORE_ONLY,
	TOGGLE_DISPLAY_DIRECTORY,
	TOGGLE_DISPLAY_PROFILES,
	TOGGLE_MESSAGING,
	TOGGLE_BOOKMARK_ATTENDEES,
	TOGGLE_PROFILE_APPEARANCE,
	TOGGLE_TOPIC_GROUP_CHATS,
	UPDATE_EVENT_SETTINGS,
	TOGGLE_FILTERS,
	SET_FILTERS,
	MODAL_IN_EDITOR,
	CREATE_EVENT_CHAT_CHANNEL,
	TOGGLE_RECAPTCHA,
	TOGGLE_PERSONALIZED_ATTENDEE_LIST,
	TOGGLE_SHOW_ADD_TO_CAL_BTN,
	TOGGLE_TRACK_MODAL,
	SET_VOD_ORDER,
	IS_UPDATING_SETTINGS,
	TOGGLE_DISPLAY_LANDING_PAGE,
	TOGGLE_DISPLAY_LIVE_EVENT_BANNER,
	SET_REJECTED_PASSCODE_MESSAGE,
	ADMIN_TOGGLE_IN_PERSON_ATTENDEE_MODE,
	TOGGLE_CLOSE_REGISTRATION,
	FORCE_QUILL_RERENDER,
	GET_GLOBAL_CURRENCIES,
	GET_EVENT_SCHEDULED_EMAILS,
	CREATE_SCHEDULED_EMAIL,
	EDIT_SCHEDULED_EMAIL,
	EDIT_SCHEDULED_EMAIL_IN_ADMIN,
	CLEAR_SCHEDULED_EMAILS,
	SET_EVENT_CUSTOM_COMPILED_CSS,
	SET_EVENT_USE_SAFE_CSS,
	SET_DISPLAY_SCHEDULED_EMAIL,
	DELETE_SCHEDULED_EMAIL,
	TOGGLE_TRANSLATIONS_V2,
	RE_RENDER_QUILL,
	GET_CHANNEL_SCHEDULED_EMAILS,
	CLEAR_CHANNEL_SCHEDULED_EMAILS,
	ADD_EVENT_TEMPLATE,
	UPDATE_EVENT_TEMPLATE,
	SET_TRANSLATION_MANIFESTS,
	REMOVE_CUSTOM_TEMPLATES,
	UPDATE_EVENT_PREVIEW_PASSWORD,
	SET_EVENT_TAGS,
	SETUP_EVENT_PREVIEW,
	PUBLISH_EVENT_PREVIEW,
	TOGGLE_DISPLAY_SESSION_LANGUAGE_DROPDOWN,
	UPDATE_SESSION_BACKUP_URL,
	UPDATE_CHANNEL_ICON,
	SET_EMAIL_LINK_LIMIT,
	SET_ACTIVE_ACCORDION_CONTAINER,
	resetHomepageModules,
	RESET_HOMEPAGE_MODULES,
	ADD_LEADERBOARD_NAV_ITEM,
	UPDATE_SESSION_FEEDBACK_SURVEY_TEXT,
	SET_MARKETING_OPT_IN_TYPE,
	GET_TEMPLATE_EVENTS,
	CREATE_TEMPLATE_EVENT,
	CLEAR_TEMPLATE_EVENTS_ERROR,
	RESET_TEMPLATE_EVENTS,
	UPDATE_SESSION_TITLE_AND_TRACKS,
	RESET_FETCH_EVENT_LOADING_STATUS,
} from '../../actions/admin/create-event';
import { GET_PRIVACY_POLICY, CLEAR_PRIVACY_POLICY } from '../../actions/admin/privacy-policy';
import { GET_TERMS_CONDITIONS, CLEAR_TERMS_CONDITIONS } from '../../actions/admin/terms-conditions';
import { updateAdminEvents } from "../../actions/admin/events";
import { GetDefaultMainNavItems, GetDefaultRegistrationSettings } from "../../utils/create-event";
import { SaveEvent } from "../../../connection/create-event";
import { Status } from '../../../types/event';
import { sortRegistrationSteps } from '../../../utils/utils';

export interface Index {
	index: number;
}

export interface CreateEventState {
	newEventRequest: CreateEventRequest | null;
	templates: Template[] | null;
	workingEvent: BrandliveEvent | null;
	selectedEvent: SelectedBrandliveEvent | null;
	loadingEvent: boolean;
	eventNotFound: boolean;
	fontPacks: FontPack[];
	colorPacks: Color[];
	workingSession: Session | null;
	editingSessionAgenda: CreateSession | null;
	saving: boolean;
	registrationStep: RegistrationStepType;
	customizeFormModalOpen: boolean;
	termsConditions: TermsConditions | null;
	privacyPolicy: PrivacyPolicy | null;
	publishingEvent: boolean;
	errorPublishingEvent: boolean;
	editorSize: 'desktop' | 'tablet' | 'mobile';
	previewMode: EPreviewTypes | null,
	publishedUrl: string | null;
	deletingSession: boolean;
	currentPostRegisterPage: string | null;
	blurEditor: boolean;
	modalInEditor: boolean;
	addModuleModalOpen: boolean;
	isSettingsUpdating: boolean;
	fetchingPublishedStatus: boolean;
	displayLiveBanner: boolean;
	moduleLayoutUpdate: number;
	forceQuillRerender: boolean;
	globalCurrencies: GlobalCurrency[] | null;
	scheduledEmails: {
		scheduledEmails?: IScheduledEmail[];
		displayEmail?: IScheduledEmail['uuid'];
		loadingEmails?: boolean;
	} | null,
	errorFetchingPublishedStatus?: boolean;
	reRenderQuillCount: number;
	errorFetchingChannelScheduledEmails?: boolean;
	fetchingChannelScheduledEmails?: boolean;
	channelScheduledEmails?: IScheduledEmail[];
	settingUpEventPreview?: boolean;
	updatingEventPreviewPassword?: boolean;
	publishingEventPreview?: boolean;
	channelIcons?: ChannelCustomizedIcon[];
	accordion: ICreateAccordion;
	moduleUpdates: number;
	errorDeletingCustomPage?: boolean;
	loadingTemplatesStatus: LoadingStatus; /** loading status for css templates (i.e., themes)*/
	templateEvents: {
		templateEvents: GetEventsResponse[];
		totalTemplates: number;
		loadingStatus: LoadingStatus; /** loading status for template events */
		error?: string | null;
	}
}

const initialState: CreateEventState = {
	newEventRequest: null,
	templates: null,
	workingEvent: null,
	selectedEvent: null,
	loadingEvent: false,
	eventNotFound: false,
	fontPacks: [],
	colorPacks: [],
	workingSession: null,
	editingSessionAgenda: null,
	saving: false,
	registrationStep: RegistrationStepType.general,
	customizeFormModalOpen: false,
	termsConditions: null,
	privacyPolicy: null,
	publishingEvent: false,
	errorPublishingEvent: false,
	editorSize: 'desktop',
	previewMode: null,
	publishedUrl: null,
	deletingSession: false,
	currentPostRegisterPage: null,
	blurEditor: false,
	modalInEditor: false,
	addModuleModalOpen: false,
	isSettingsUpdating: false,
	fetchingPublishedStatus: true,
	displayLiveBanner: false,
	moduleLayoutUpdate: 0,
	forceQuillRerender: false,
	globalCurrencies: null,
	scheduledEmails: null,
	errorFetchingPublishedStatus: false,
	reRenderQuillCount: 0,
	settingUpEventPreview: false,
	updatingEventPreviewPassword: false,
	publishingEventPreview: false,
	channelIcons: [],
	accordion: {},
	moduleUpdates: 0,
	errorDeletingCustomPage: false,
	loadingTemplatesStatus: LoadingStatus.PreLoading,
	templateEvents: {
		templateEvents: [],
		totalTemplates: 0,
		loadingStatus: LoadingStatus.PreLoading,
		error: null,
	}
};

let timeout: NodeJS.Timeout;

function getState(state: CreateEventState = initialState, action: Action): CreateEventState {
	switch (action.type) {
		case CREATE_NEW_EVENT: {
			return { ...state, newEventRequest: action.payload };
		}
		case LOAD_TEMPLATES: {
			return handle(state, action, {
				start: state => ({
					...state,
					loadingTemplatesStatus: LoadingStatus.Loading,
				}),
				success: state => {
					return { ...state, templates: action.payload };
				},
				finish: state => ({
					...state,
					loadingTemplatesStatus: LoadingStatus.Done,
				}),
			});
		}
		case CREATE_NEW_SESSION: {
			if (state.newEventRequest) {
				return {
					...state,
					newEventRequest: {
						...state.newEventRequest,
						sessions: [...state.newEventRequest.sessions, action.payload]
					}
				};
			} else return state;
		}
		case SET_EVENT_NAME: {
			if (state.newEventRequest) {
				return {
					...state,
					newEventRequest: { ...state.newEventRequest, name: action.payload }
				};
			} else {
				return state;
			}
		}
		case SET_WORKING_EVENT: {
			return {
				...state,
				workingEvent: action.payload
			};
		}
		case SET_SELECTED_EVENT: {
			return {
				...state,
				selectedEvent: action.payload
			};
		}
		case CLEAR_SELECTED_EVENT: {
			return {
				...state,
				selectedEvent: null
			};
		}
		case CLEAR_WORKING_EVENT: {
			return {
				...state,
				workingEvent: null,
				eventNotFound: false,
				loadingEvent: false,
			};
		}
		case BLUR_EDITOR: {
			return {
				...state,
				blurEditor: true,
			};
		}
		case MODAL_IN_EDITOR: {
			return {
				...state,
				modalInEditor: action.payload
			};
		}
		case LOAD_WORKING_EVENT: {
			return handle(state, action, {
				start: (state) => ({
					...state,
					loadingEvent: true,
					eventNotFound: false,
				}),
				success: state => {
					if (action.payload.error) {
						return ({ ...state, workingEvent: null, eventNotFound: true });
					}
					const { channel_event_icons, ...workingEvent } = action.payload;
					return ({
						...state,
						workingEvent,
						eventNotFound: false,
						//if there is nothing in the table, it returned back channel_event_icons = [null]
						//That s why I have a check like this.
						channelIcons: (channel_event_icons[0] === null) ? [] : channel_event_icons
					});
				},
				failure: state => {
					return ({ ...state, workingEvent: null, eventNotFound: true });
				},
				finish: state => {
					return {
						...state,
						loadingEvent: false,
						blurEditor: false,
					};
				}
			});
		}
		case ADD_NEW_SESSION_TO_STORE: {
			if (state.workingEvent) {
				const { timestamp, end_timestamp } = action.payload;
				const newSession = {
					...action.payload,
					timestamp: new Date(timestamp).valueOf(),
					end_timestamp: new Date(end_timestamp).valueOf()
				};
				const selectedEvent = state?.selectedEvent ? { ...state.selectedEvent } : null;
				if (selectedEvent && selectedEvent?.uuid === action?.payload?.uuid) {
					selectedEvent.sessions = [newSession, ...(selectedEvent?.sessions || [])];
				}
				return ({
					...state,
					workingEvent: {
						...state.workingEvent,
						sessions: [newSession, ...(state.workingEvent?.sessions ?? [])],
					},
					selectedEvent,
				});
			} else {
				return state;
			}
		}
		case ADD_HOMEPAGE_TO_WORKING_EVENT: {
			if (!state?.workingEvent) return state;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					homepage: action.payload,
				},
			};
		}
		case ADD_NEW_SESSION: {
			return handle(state, action, {
				success: state => {
					if (action.payload.error) {
						return state;
					} else if (state.workingEvent) {
						const { timestamp, end_timestamp } = action.payload;
						const newSession = {
							...action.payload,
							timestamp: new Date(timestamp).valueOf(),
							end_timestamp: new Date(end_timestamp).valueOf()
						};
						const selectedEvent = state?.selectedEvent ? { ...state.selectedEvent } : null;
						if (selectedEvent && selectedEvent?.uuid === action?.payload?.uuid) {
							selectedEvent.sessions = [newSession, ...(selectedEvent?.sessions || [])];
						}

						const settings = state.workingEvent.settings;

						//if the new session is of the on-demand type AND there's a vod order
						//we have to add the new session to the vod order
						if (settings.vodOrder && newSession.session_type === SessionTypesEnum.onDemand) {
							settings.vodOrder = [newSession.session, ...settings.vodOrder];
						}

						return ({
							...state,
							workingEvent: {
								...state.workingEvent,
								sessions: [newSession, ...(state.workingEvent?.sessions ?? [])],
								settings
							},
							selectedEvent,
						});
					} else {
						return state;
					}
				},
			});
		}
		case DUPLICATE_SESSION: {
			return handle(state, action, {
				success: state => {
					if (action.payload.error) {
						return state;
					} else if (state.workingEvent) {
						const { timestamp, end_timestamp } = action.payload;
						const newSession = {
							...action.payload,
							timestamp: new Date(timestamp).valueOf(),
							end_timestamp: new Date(end_timestamp).valueOf()
						};
						return ({ ...state, workingEvent: { ...state.workingEvent, sessions: [newSession, ...(state.workingEvent?.sessions ?? [])] } });
					} else {
						return state;
					}
				},
			});
		}
		case DELETE_SESSION: {
			return handle(state, action, {
				start: state => ({ ...state, deletingSession: true }),
				finish: state => ({ ...state, deletingSession: false }),
				success: state => {
					if (action.payload.error) {
						return state;
					}
					if (state.workingEvent) {
						const { sessions } = state.workingEvent;
						const updatedSessions = sessions.filter(session => session.session !== action.payload.session);
						return {
							...state,
							workingEvent: { ...state.workingEvent, sessions: updatedSessions },
							selectedEvent: state?.selectedEvent ? {
								...state.selectedEvent,
								sessions: updatedSessions,
								_sessions: updatedSessions,
							} : null,
						};
					}
					if (state.selectedEvent) {
						const { sessions } = state.selectedEvent;
						const updatedSessions = sessions.filter(session => session.session !== action.payload.session);
						return {
							...state,
							selectedEvent: {
								...state.selectedEvent,
								sessions: updatedSessions,
								_sessions: updatedSessions,
							},
						};
					}
					return state;
				},
			});
		}
		case REMOVE_SESSION: {
			let copy = { ...state };
			if (state.workingEvent) {
				copy = {
					...copy,
					workingEvent: {
						...state.workingEvent,
						sessions: state.workingEvent.sessions.filter(session => session.session !== action.payload.session),
					},
				};
			}
			if (state?.selectedEvent?._sessions || state?.selectedEvent?.sessions) {
				copy = {
					...copy,
					selectedEvent: {
						...state.selectedEvent,
						sessions: state?.selectedEvent?.sessions?.filter(s => s.session !== action.payload.session) ?? null,
						_sessions: state?.selectedEvent?._sessions?.filter(s => s.session !== action.payload.session) ?? null,
					}
				};
			}
			return copy;
		}
		case REMOVE_EVENT: {
			return {
				...state,
				workingEvent: state?.workingEvent?.uuid === action.payload ? null : state.workingEvent,
				selectedEvent: null,
			};
		}
		case UPDATE_SESSION_CARD:
		case UPDATE_SESSION_INFO: {
			return handle(state, action, {
				success: state => {
					if (action.payload.error) {
						return state;
					} else if (state.workingEvent) {
						const { sessions } = state.workingEvent;
						const updatedSessions = [...sessions];
						const updateIndex = updatedSessions.findIndex((session) => session.uuid === action.payload.uuid);

						if (updateIndex >= 0) {
							updatedSessions.splice(updateIndex, 1, action.payload);
						}

						return ({ ...state, workingEvent: { ...state.workingEvent, sessions: updatedSessions } });
					} else {
						return state;
					}
				}
			});
		}
		case IS_UPDATING_SETTINGS: {
			return {
				...state,
				isSettingsUpdating: action.payload,
			};
		}
		case UPDATE_EVENT_SETTINGS: {
			if (!state.workingEvent) return state;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					settings: action.payload,
				},
			};
		}
		case SET_REGISTRATION_ON: {
			return {
				...state,
				workingEvent: {
					...state.workingEvent as BrandliveEvent,
					registration_on: action.payload as boolean,
				}
			};
		}
		case SET_REGISTRATION_TYPE: {
			if (state.workingEvent?.registration_settings) {
				return ({
					...state,
					workingEvent: {
						...state.workingEvent as BrandliveEvent,
						registration_settings: {
							...state.workingEvent?.registration_settings,
							type: action.payload,
						},
					},
				});
			} else {
				return state;
			}
		}
		case UPDATE_REGISTRATION_SETTINGS: {
			if (!state.workingEvent) return state;
			return handle(state, action, {
				success: (state) => {
					if (!state.workingEvent) return state;
					return {
						...state,
						workingEvent: {
							...state.workingEvent,
							registration_settings: action.payload
						}
					};
				}
			});
		}
		case SET_REGISTRATION_FEATURE: {
			if (state.workingEvent?.registration_settings) {
				return ({
					...state,
					workingEvent: {
						...state.workingEvent as BrandliveEvent,
						registration_settings: {
							...state.workingEvent.registration_settings,
							[action.payload.feature]: action.payload.on
						}
					}
				});
			} else {
				return state;
			}
		}
		case SET_CUSTOM_PASSCODE_LABEL: {
			if (state.workingEvent?.registration_settings) {
				return ({
					...state,
					workingEvent: {
						...state.workingEvent as BrandliveEvent,
						registration_settings: {
							...state.workingEvent.registration_settings,
							customPasscodeLabel: action.payload
						}
					}
				});
			} else {
				return state;
			}
		}
		case SET_REJECTED_PASSCODE_MESSAGE: {
			if (state.workingEvent?.registration_settings) {
				return ({
					...state,
					workingEvent: {
						...state.workingEvent as BrandliveEvent,
						registration_settings: {
							...state.workingEvent.registration_settings,
							customRejectedPasscodeMessage: action.payload
						}
					}
				});
			} else {
				return state;
			}
		}
		case SET_REGISTRATION_SINGLE_SIGN_ON: {
			if (state.workingEvent?.registration_settings) {
				return ({
					...state,
					workingEvent: {
						...state.workingEvent,
						registration_settings: {
							...state.workingEvent.registration_settings,
							singleSignOn: {
								...state.workingEvent.registration_settings.singleSignOn,
								isOn: action.payload
							}
						}
					}
				});
			} else {
				return state;
			}
		}

		case CHECK_REGISTRATION_SINGLE_SIGN_ON: {
			const nextState = { ...state };
			if (!nextState.workingEvent?.registration_settings?.singleSignOn) return nextState;

			const isSingleSignOnSwitchedOn = nextState.workingEvent.registration_settings.singleSignOn.isOn;
			const hasConfiguredSingleSignOn = !!nextState.workingEvent.registration_settings.singleSignOn.singleSignOns?.length;

			// we don't just want the feature to be switched on but not configured. If the user has not configured any single sign on, 
			// flip the feature back off.
			if (isSingleSignOnSwitchedOn && !hasConfiguredSingleSignOn) {
				nextState.workingEvent.registration_settings.singleSignOn.isOn = false;
				return nextState;
			} else {
				return nextState;
			}
		}

		case SET_REGISTRATION_SSO_DISPLAY_TOP: {
			if (state.workingEvent?.registration_settings) {
				return ({
					...state,
					workingEvent: {
						...state.workingEvent,
						registration_settings: {
							...state.workingEvent.registration_settings,
							singleSignOn: {
								...state.workingEvent.registration_settings.singleSignOn,
								displayTop: action.payload
							}
						}
					}
				});
			} else {
				return state;
			}
		}
		case SET_REGISTRATION_SINGLE_SIGN_ON_TYPES: {
			if (state.workingEvent?.registration_settings) {
				return ({
					...state,
					workingEvent: {
						...state.workingEvent,
						registration_settings: {
							...state.workingEvent.registration_settings,
							singleSignOn: {
								...state.workingEvent.registration_settings.singleSignOn,
								singleSignOns: action.payload
							}
						}
					}
				});
			} else {
				return state;
			}
		}
		case SET_BLOCKED_DOMAIN_EMAILS: {
			if (state.workingEvent?.registration_settings) {
				return ({
					...state,
					workingEvent: {
						...state.workingEvent as BrandliveEvent,
						registration_settings: {
							...state.workingEvent.registration_settings,
							blockedDomainEmails: action.payload
						}
					}
				});
			} else {
				return state;
			}
		}
		case ADD_REGISTRATION_REQUIREMENT: {
			if (!state.workingEvent) return state;
			const workingEvent = { ...state.workingEvent };
			const { type, newRequirement }: {
				type: GateTypes;
				newRequirement: Requirement
			} = action.payload;

			const requirementsCopy = { ...workingEvent.registration_settings?.requirements };

			if (type === GateTypes.passcode_list) {
				if (requirementsCopy[GateTypes.passcode_list]?.length) {
					requirementsCopy[GateTypes.passcode_list]?.push(newRequirement);
				} else {
					requirementsCopy[GateTypes.passcode_list] = [newRequirement];
				}
			} else {
				requirementsCopy[type] = newRequirement;
			}

			if (workingEvent.registration_settings) {
				workingEvent.registration_settings = {
					...workingEvent.registration_settings,
					requirements: requirementsCopy
				};
			} else {
				workingEvent.registration_on = true;
				workingEvent.registration_settings = {
					...GetDefaultRegistrationSettings(),
					requirements: requirementsCopy
				};
			}

			return ({ ...state, workingEvent: workingEvent });
		}

		case REMOVE_REGISTRATION_REQUIREMENT: {
			if (!state.workingEvent) return state;
			const workingEvent = { ...state.workingEvent };
			const { type, passcodeListIndex }: {
				type: GateTypes;
				passcodeListIndex: number
			} = action.payload;

			const requiredQnsStepsCopy = workingEvent?.required_registration_questions ? [...workingEvent.required_registration_questions] : null;
			const requirementsCopy = { ...workingEvent.registration_settings?.requirements };

			if (type === GateTypes.passcode_list) {
				if (requirementsCopy[GateTypes.passcode_list]?.length === 1) {
					delete requirementsCopy[GateTypes.passcode_list];
				} else {
					requirementsCopy[GateTypes.passcode_list]?.splice(passcodeListIndex, 1);
				}
			} else {
				delete requirementsCopy[type];
			}

			if (workingEvent.registration_settings) {
				workingEvent.registration_settings = {
					...workingEvent.registration_settings,
					requirements: requirementsCopy,
				};
			}

			return {
				...state,
				workingEvent: {
					...workingEvent,
					required_registration_questions: requiredQnsStepsCopy,
				},
			};
		}

		case UPDATE_REGISTRATION_REQUIREMENT: {
			if (!state.workingEvent) return state;
			const workingEvent = { ...state.workingEvent };
			const { type, passcodeListIndex, updatedRequirement }: {
				type: GateTypes;
				passcodeListIndex: number;
				updatedRequirement: Requirement
			} = action.payload;

			const requirementsCopy = { ...workingEvent.registration_settings?.requirements };

			if (type === GateTypes.passcode_list) {
				requirementsCopy[type] = requirementsCopy[type]?.map((passcodeList, index) => {
					if (index === passcodeListIndex) return updatedRequirement;
					else return passcodeList;
				});
			} else {
				requirementsCopy[type] = updatedRequirement;
			}

			if (workingEvent.registration_settings) {
				workingEvent.registration_settings = {
					...workingEvent.registration_settings,
					requirements: requirementsCopy
				};
			}

			return { ...state, workingEvent: workingEvent };
		}
		case CHOOSE_REGISTRATION_STEP: {
			return { ...state, registrationStep: action.payload };
		}
		case TOGGLE_CUSTOMIZE_FORM_MODAL: {
			return { ...state, customizeFormModalOpen: action.payload };
		}
		case UPDATE_REGISTRATION_STEPS: {
			if (!state.workingEvent) return state;

			const registrationSteps = sortRegistrationSteps(action.payload);

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					registration_steps: registrationSteps
				}
			};


		}
		case UPDATE_REQUIRED_REGISTRATION_QUESTIONS: {
			if (!state.workingEvent) return state;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					required_registration_questions: action.payload
				}
			};
		}

		//not currently in use, but we are planning at some point to add the ability to add more steps
		case ADD_REGISTRATION_STEP: {
			if (!state.workingEvent) return state;

			if (!state.workingEvent.registration_steps) {
				console.error("Tried adding a registration step to an empty set.");
				return state;
			}

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					registration_steps: [
						...state.workingEvent.registration_steps,
						action.payload
					]
				}
			};
		}

		case ADD_TICKETING_SET: {
			if (!state.workingEvent) return state;

			let _workingEvent = { ...state.workingEvent };

			if (!_workingEvent.registration_steps) {
				console.error("Tried adding a registration step to an empty set.");
				return state;
			}

			// turn on the ticketing step if it isn't on already
			const exists = _workingEvent.registration_steps.find(step => step.type == RegistrationStepType.ticketing) !== undefined;
			if (!exists) {
				const step: RegistrationStep = {
					isOn: true,
					type: RegistrationStepType.ticketing,
				};

				_workingEvent.registration_steps.push(step);
			}

			_workingEvent.registration_steps = _workingEvent.registration_steps.map(step => {
				const stepCopy = { ...step };
				if (stepCopy.type === RegistrationStepType.ticketing) {
					stepCopy.ticketing = [...stepCopy.ticketing ?? [], action.payload];
					stepCopy.isOn = true;
				}

				return stepCopy;
			});

			// turn on send email if its not already (emails are needed for ticketing)
			const sendEmails = _workingEvent.registration_settings?.sendEmailConfirmation;
			if (!sendEmails) {
				if (!_workingEvent.registration_settings) {
					console.error("Tried modifying registration settings that don't exist.");
					return state;
				}
				_workingEvent = {
					..._workingEvent,
					registration_settings: {
						..._workingEvent.registration_settings,
						sendEmailConfirmation: true
					}
				};
			}

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case UPDATE_TICKETING_SET: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };

			if (!_workingEvent.registration_steps) {
				console.error("Tried adding a registration step to an empty set.");
				return state;
			}

			const { set, index } = action.payload;

			_workingEvent.registration_steps = _workingEvent.registration_steps.map(step => {
				if (step.type === RegistrationStepType.ticketing && step.ticketing) {
					step.ticketing = step.ticketing.map((ticketingSet, _index) => {
						if (_index === index) {
							return set;
						} else {
							return ticketingSet;
						}
					});
				}

				return step;
			});

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case GET_GLOBAL_CURRENCIES: {
			return handle(state, action, {
				success: state => {
					return {
						...state,
						globalCurrencies: action.payload
					};
				}
			});
		}

		case REMOVE_TICKETING_SET: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };

			if (!_workingEvent.registration_steps) {
				console.error("Tried adding a registration step to an empty set.");
				return state;
			}

			let emptyTicketStep = null;

			_workingEvent.registration_steps = _workingEvent.registration_steps.map((step, stepIndex) => {
				const stepCopy = { ...step };
				if (stepCopy.type === RegistrationStepType.ticketing && stepCopy.ticketing) {
					stepCopy.ticketing = stepCopy.ticketing.filter((tick, index) => {
						return index !== action.payload;
					});
					if (!stepCopy?.ticketing?.length) {
						emptyTicketStep = stepIndex;
					}
				}
				return stepCopy;
			});

			// if there are no tickets, ticketing should be removed from registration steps
			if (emptyTicketStep) {
				_workingEvent.registration_steps.splice(emptyTicketStep, 1);
			}

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case TOGGLE_REGISTRATION_QUESTION_REQUIRED: {
			if (!state.workingEvent) return state;

			if (action.payload.required) {
				return {
					...state,
					workingEvent: {
						...state.workingEvent,
						required_registration_questions: [
							...state.workingEvent.required_registration_questions ?? [],
							action.payload.question
						]
					}
				};
			} else {
				return {
					...state,
					workingEvent: {
						...state.workingEvent,
						required_registration_questions: state.workingEvent.required_registration_questions?.filter((_question: number) => {
							return _question !== action.payload.question;
						}) ?? []
					}
				};
			}
		}
		case SET_REGISTRATION_QUESTIONS: {
			if (!state.workingEvent) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					registration_questions: action.payload.questions,
					required_registration_questions: action.payload.required_questions
				}
			};
		}
		case LOAD_FONT_PACKS: {
			return handle(state, action, {
				success: state => ({ ...state, fontPacks: action.payload })
			});
		}
		case SET_SELECTED_FONT: {
			if (!state.workingEvent) return state;

			let _workingEvent = { ...state.workingEvent };

			_workingEvent = {
				..._workingEvent,
				settings: {
					..._workingEvent.settings,
					design: {
						..._workingEvent.settings.design,
						font: action.payload
					}
				}
			};

			return {
				...state,
				workingEvent: _workingEvent
			};
		}
		case ADD_NEW_FONT_PACK: {
			if (!state.workingEvent) return state;

			return {
				...state,
				fontPacks: [action.payload, ...state.fontPacks]
			};
		}
		case DELETE_FONT_PACKS: {
			return handle(state, action, {
				success: state => {
					const {
						// cannotDelete, //cannot delete messaging handled in Content Reducer
						deletedFonts
					}: {
						// cannotDelete: number[];
						deletedFonts: number[];
					} = action.payload;

					let updatedFonts = [...state.fontPacks];

					if (deletedFonts?.length === 1) {
						const fontIndex = updatedFonts.findIndex(font => font.font_pack === deletedFonts[0]);
						if (fontIndex >= 0) updatedFonts.splice(fontIndex, 1);
					} else {
						updatedFonts = updatedFonts.filter(font => !deletedFonts.includes(font.font_pack));
					}

					return {
						...state,
						fontPacks: updatedFonts
					};
				}
			});
		}
		case LOAD_COLOR_PACKS: {
			return handle(state, action, {
				success: state => {
					return ({ ...state, colorPacks: action.payload });
				}
			});
		}
		case SET_SELECTED_COLOR: {
			if (!state.workingEvent) return state;

			let _workingEvent = { ...state.workingEvent };

			_workingEvent = {
				..._workingEvent,
				settings: {
					..._workingEvent.settings,
					design: {
						..._workingEvent.settings.design,
						colors: action.payload
					}
				}
			};

			return {
				...state,
				workingEvent: _workingEvent
			};
		}
		case ADD_NEW_COLOR_PACK: {
			return {
				...state,
				colorPacks: [action.payload, ...state.colorPacks]
			};
		}
		case SAVE_COLOR_PACK: {

			let _workingEvent = state.workingEvent;

			if (_workingEvent) {
				_workingEvent = {
					..._workingEvent,
					settings: {
						..._workingEvent.settings,
						design: {
							..._workingEvent.settings.design,
							colors: action.payload
						}
					}
				};
			}

			return {
				...state,
				colorPacks: state.colorPacks.map((color: Color) => {
					if (color.color_pack === action.payload.color_pack) {
						return action.payload;
					} else return color;
				}),
				workingEvent: _workingEvent
			};
		}
		case DELETE_COLOR_PACKS: {
			return handle(state, action, {
				success: state => {
					const {
						// cannotDelete, //cannot delete messaging handled in Content Reducer
						deletedColors
					}: {
						// cannotDelete: number[];
						deletedColors: number[];
					} = action.payload;

					let updatedColors = [...state.colorPacks];

					if (deletedColors?.length === 1) {
						const colorIndex = updatedColors.findIndex(color => color.color_pack === deletedColors[0]);
						if (colorIndex >= 0) updatedColors.splice(colorIndex, 1);
					} else {
						updatedColors = updatedColors.filter(color => !deletedColors.includes(color.color_pack));
					}

					return {
						...state,
						colorPacks: updatedColors
					};
				}
			});
		}
		case SET_DESIGN_STYLE: {
			if (!state.workingEvent) return state;

			let _workingEvent = { ...state.workingEvent };

			_workingEvent = {
				..._workingEvent,
				settings: {
					..._workingEvent.settings,
					design: {
						..._workingEvent.settings.design,
						style: {
							..._workingEvent.settings.design.style,
							style: action.payload
						}
					}
				}
			};

			return {
				...state,
				workingEvent: _workingEvent
			};
		}
		case SET_DESIGN_SHAPE: {
			if (!state.workingEvent) return state;

			let _workingEvent = { ...state.workingEvent };
			_workingEvent = {
				..._workingEvent,
				settings: {
					..._workingEvent.settings,
					design: {
						..._workingEvent.settings.design,
						style: {
							..._workingEvent.settings.design.style,
							shape: action.payload
						}
					}
				}
			};

			return {
				...state,
				workingEvent: _workingEvent
			};
		}
		case SET_DESIGN_COLORS: {
			if (!state.workingEvent) return state;

			let _workingEvent = { ...state.workingEvent };

			_workingEvent = {
				..._workingEvent,
				settings: {
					..._workingEvent.settings,
					design: {
						..._workingEvent.settings.design,
						colors: action.payload
					}
				}
			};

			return {
				...state,
				workingEvent: _workingEvent
			};
		}
		case SET_CUSTOM_CSS: {
			if (!state.workingEvent) return state;

			let _workingEvent = { ...state.workingEvent };

			_workingEvent = {
				..._workingEvent,
				settings: {
					..._workingEvent.settings,
					customCSS: action.payload
				}
			};

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case TOGGLE_HOMEPAGE_MODULE: {
			if (!state.workingEvent) return state;

			let _workingEvent = { ...state.workingEvent };
			if (!_workingEvent?.homepage) return state;

			_workingEvent = {
				..._workingEvent,
				homepage: {
					..._workingEvent.homepage,
					modules: _workingEvent.homepage.modules.map((module: PageModule) => {
						if (module.id === action.payload.id) {
							module.is_on = !module.is_on;
						}

						return module;
					})
				}
			};

			return { ...state, workingEvent: _workingEvent };
		}

		case TOGGLE_POST_REGISTER_HOME_MODULE: {
			if (state.workingEvent?.homepage?.post_register_home_modules) {
				return {
					...state,
					workingEvent: {
						...state.workingEvent,
						homepage: {
							...state.workingEvent?.homepage,
							post_register_home_modules: state.workingEvent?.homepage?.post_register_home_modules.map(module => {
								if (module.id === action.payload.moduleId) {
									return {
										...module,
										is_on: action.payload.is_on,
									};
								}
								return module;
							}),
						}
					}
				};
			}
			return state;
		}

		case UPDATE_HOMEPAGE_MODULE: {
			if (!state.workingEvent) return state;

			const updateModules = (modulesToUpdate: PageModule[], updatedModule: PageModule) => {
				return modulesToUpdate.map((module: PageModule) => {
					if (module.id === updatedModule.id) return updatedModule;
					return module;
				});
			};

			let _workingEvent = { ...state.workingEvent };
			if (!_workingEvent?.homepage) return state;

			if (state.currentPostRegisterPage === NavMainItems.Home) { //Update Post registered Home page modules
				// if currentPage === Home, update post-register-homepage
				_workingEvent = {
					..._workingEvent,
					homepage: {
						..._workingEvent.homepage,
						post_register_home_modules: updateModules(_workingEvent.homepage.post_register_home_modules, action.payload)
					}
				};
			} else if (state.currentPostRegisterPage) { //Update Custom Pages Modules
				//state.currentPostRegisterPage should be custom_page.path for any Custom Page
				const customPages = state.workingEvent.custom_pages?.map(page => {
					if (page.path !== state.currentPostRegisterPage || !page.modules) return page;

					const updatedModules = updateModules(page.modules, action.payload);

					return {
						...page,
						modules: updatedModules
					};
				});

				_workingEvent = {
					..._workingEvent,
					custom_pages: customPages
				};
			} else { //Update Landing Page Modules
				_workingEvent = {
					..._workingEvent,
					homepage: {
						..._workingEvent.homepage,
						modules: updateModules(_workingEvent.homepage.modules, action.payload)
					}
				};
			}

			_workingEvent.status = 2;
			return { ...state, workingEvent: _workingEvent };
		}

		case SET_HOMEPAGE_MODULES: {
			if (!state.workingEvent) return state;

			let _workingEvent = { ...state.workingEvent };
			if (!_workingEvent?.homepage) return state;

			_workingEvent = {
				..._workingEvent,
				homepage: {
					..._workingEvent.homepage,
					modules: action.payload
				}
			};

			return { ...state, workingEvent: _workingEvent };
		}

		case RESET_HOMEPAGE_MODULES: {
			if (!state.workingEvent) return state;

			let _workingEvent = { ...state.workingEvent };
			if (!_workingEvent?.homepage) return state;
			_workingEvent = {
				..._workingEvent,
				homepage: {
					..._workingEvent.homepage,
					modules: action.payload,
				}
			};

			return {
				...state,
				workingEvent: _workingEvent,
				moduleUpdates: state.moduleUpdates + 1,
			};
		}

		case UPDATE_HOMEPAGE_HEADER: {
			if (!state.workingEvent) return state;

			let _workingEvent = { ...state.workingEvent };
			if (!_workingEvent?.homepage) return state;

			_workingEvent = {
				..._workingEvent,
				homepage: {
					..._workingEvent.homepage,
					header: action.payload
				}
			};

			return { ...state, workingEvent: _workingEvent };
		}

		case UPDATE_HOMEPAGE_FOOTER: {
			if (!state.workingEvent) return state;

			let _workingEvent = { ...state.workingEvent };
			if (!_workingEvent?.homepage) return state;

			_workingEvent = {
				..._workingEvent,
				homepage: {
					..._workingEvent.homepage,
					footer: action.payload
				}
			};

			return { ...state, workingEvent: _workingEvent };
		}

		case UPDATE_HOMEPAGE_MAIN_NAV: {
			if (!state.workingEvent || !state.workingEvent.homepage) return state;

			const _workingEvent = { ...state.workingEvent };
			if (_workingEvent?.homepage) {
				return {
					...state,
					workingEvent: {
						..._workingEvent,
						homepage: {
							..._workingEvent.homepage,
							event_main_nav_items: action.payload,
						},
					},
				};
			}
			return state;
		}

		case UPDATE_HOMEPAGE_PROFILE_NAV: {
			if (!state.workingEvent || !state.workingEvent.homepage) return state;

			const _workingEvent = { ...state.workingEvent };
			if (_workingEvent?.homepage) {
				return {
					...state,
					workingEvent: {
						..._workingEvent,
						homepage: {
							..._workingEvent.homepage,
							event_profile_nav_items: action.payload,
						},
					},
				};
			}
			return state;
		}

		case UPDATE_POST_REGISTER_HOME_MODULES: {
			if (!state.workingEvent || !state.workingEvent.homepage) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					homepage: {
						...state.workingEvent.homepage,
						post_register_home_modules: action.payload,
					}
				}
			};
		}

		case ADD_PAGE_MODULE: {
			if (!state.workingEvent) return state;

			let _workingEvent = { ...state.workingEvent };
			if (!_workingEvent?.homepage) return state;

			if (state.currentPostRegisterPage === NavMainItems.Home) {
				// add page_module to post register homepage
				_workingEvent = {
					..._workingEvent,
					homepage: {
						..._workingEvent.homepage,
						post_register_home_modules: [..._workingEvent.homepage.post_register_home_modules, action.payload]
					}
				};
			} else if (state.currentPostRegisterPage) { //Add module to custom page
				//state.currentPostRegisterPage should be custom_page.path for any Custom Page
				const customPages = state.workingEvent.custom_pages?.map(page => {
					if (page.path !== state.currentPostRegisterPage) return page;

					const updatedModules = page.modules ? [...page.modules, action.payload] : [action.payload];
					return {
						...page,
						modules: updatedModules
					};
				});
				_workingEvent = {
					..._workingEvent,
					custom_pages: customPages
				};
			} else {
				// add page_module to workingEvent.homepage.modules
				_workingEvent = {
					..._workingEvent,
					homepage: {
						..._workingEvent.homepage,
						modules: [..._workingEvent.homepage.modules, action.payload]
					}
				};
			}
			return { ...state, workingEvent: _workingEvent };
		}

		case ADD_POST_REGISTER_HOME_PAGE_MODULE: {
			return handle(state, action, {
				success: prevState => {
					if (!prevState.workingEvent || !prevState.workingEvent?.homepage?.post_register_home_modules) return prevState;
					return {
						...prevState,
						workingEvent: {
							...prevState.workingEvent,
							homepage: {
								...prevState.workingEvent.homepage,
								post_register_home_modules: [
									...prevState.workingEvent.homepage.post_register_home_modules,
									action.payload,
								]
							}
						}
					};
				},
				failure: prevState => {
					console.log('FAILURE');
					return prevState;
				},
			});
		}

		case SET_REGISTRATION_HEADER: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };
			if (!_workingEvent?.registration_settings) return state;

			_workingEvent.registration_settings.title = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}


		case SET_REGISTRATION_DESCRIPTION: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };
			if (!_workingEvent?.registration_settings) return state;

			_workingEvent.registration_settings.description = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case SET_REGISTRATION_IMAGE: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };
			if (!_workingEvent?.registration_settings) return state;

			_workingEvent.registration_settings.image = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case SET_REGISTRATION_LOGO: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };
			if (!_workingEvent?.registration_settings) return state;

			_workingEvent.registration_settings.logo = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case SET_EVENT_CUSTOM_CSS: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };

			_workingEvent.custom_css = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case SET_EVENT_CUSTOM_COMPILED_CSS: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };

			_workingEvent.custom_css_compiled = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case SET_EVENT_USE_SAFE_CSS: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };

			_workingEvent.use_safe_css = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case REMOVE_IN_CREATION_PROGRESS_SESSION: {
			if (!state?.newEventRequest?.sessions) return state;
			return {
				...state,
				newEventRequest: {
					...state.newEventRequest,
					sessions: state.newEventRequest.sessions.filter((session) => session.uid !== action.payload),
				},
			};
		}

		case EDIT_SESSION_AGENDA: {
			if (!action.payload && action.payload !== 0) {
				return {
					...state,
					editingSessionAgenda: null,
				};
			}
			const matchedSession: CreateSession | null = state?.newEventRequest?.sessions?.find((value) => value.uid === action.payload) || null;
			if (matchedSession) {
				return {
					...state,
					editingSessionAgenda: matchedSession,
				};
			}
			return state;
		}

		case UPDATE_EDITING_SESSION_BY_UID: {
			if (!action.payload) return state;
			return {
				...state,
				newEventRequest: state?.newEventRequest ? {
					...state.newEventRequest,
					sessions: state?.newEventRequest?.sessions?.map((session) => {
						if (action?.payload?.uid === session?.uid) return action.payload;
						return session;
					}) || [],
				} : null,
				editingSessionAgenda: null,
			};
		}

		case CLEAR_NEW_EVENT_REQUEST: {
			return { ...state, newEventRequest: action.payload };
		}

		case UPDATE_WORKING_EVENT: {
			return ({
				...state,
				workingEvent: action.payload,
			});
		}

		case MODULE_LAYOUT_UPDATE: {
			return ({
				...state,
				moduleLayoutUpdate: state.moduleLayoutUpdate + 1,
			});
		}

		case ADD_WORKING_EVENT_HOMEPAGE: {
			return handle(state, action, {
				success: (state) => {
					if (!state.workingEvent) return state;
					const _workingEvent = { ...state.workingEvent };
					return {
						...state,
						workingEvent: {
							..._workingEvent,
							homepage: {
								...action.payload,
								event_main_nav_items: GetDefaultMainNavItems()
							}
						}
					};
				},
				failure: state => state,
			});
		}

		case IS_SAVING: {
			return {
				...state,
				saving: action.payload,
			};
		}

		case SET_AGENDA_IMAGE: {
			if (!state.workingEvent) return state;
			const { url, session } = action.payload;

			// find the matching session and set the url to the image field
			const _workingEvent = { ...state.workingEvent };
			return {
				...state,
				workingEvent: {
					..._workingEvent,
					sessions: _workingEvent.sessions.map((_workingSession: Session) => {
						if (_workingSession.session !== session) return _workingSession;
						return {
							..._workingSession,
							image: url,
						};
					}),
				},
			};
		}

		case PUBLISH_EVENT: {
			return handle(state, action, {
				success: (state) => {
					if (!state.workingEvent) return state;
					const _workingEvent = { ...state.workingEvent };
					return {
						...state,
						errorPublishingEvent: false,
						publishingEvent: false,
						workingEvent: {
							..._workingEvent,
							status: 1
						}
					};
				},
				start: (state) => ({ ...state, publishingEvent: true }),
				failure: (state) => {
					return ({ ...state, errorPublishingEvent: true });
				}
			});
		}

		case UPDATE_ALL_EVENT_SESSIONS_OVERLAY_CHAT: {
			if (!state.workingEvent) return state;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					sessions: state.workingEvent.sessions.map(session => ({
						...session,
						layout: {
							...session.layout,
							overlayChat: !!action.payload,
						}
					}))
				}
			};
		}

		case UPDATE_ALL_EVENT_SESSIONS_LAYOUT_TABS: {
			if (!state.workingEvent) return state;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					sessions: state.workingEvent.sessions.map(session => ({
						...session,
						layout: {
							...session.layout,
							tabs: action.payload,
						}
					}))
				}
			};
		}

		case UPDATE_WORKING_EVENT_SESSION: {
			if (!state.workingEvent) return state;
			const updatedSession: Session = action.payload;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					sessions: state.workingEvent.sessions.map(session => {
						if (session.uuid === updatedSession.uuid) return updatedSession;
						return session;
					})
				}
			};
		}

		case GET_PRIVACY_POLICY: {
			return handle(state, action, {
				success: state => {
					// only update privacyPolicy if it still matches the current workingEvent
					if (state.workingEvent?.privacy_policy === action.payload?.privacy_policy) {
						return { ...state, privacyPolicy: action.payload };
					} else {
						return state;
					}
				}
			});
		}

		case CLEAR_PRIVACY_POLICY: {
			return {
				...state,
				privacyPolicy: null,
			};
		}

		case GET_TERMS_CONDITIONS: {
			return handle(state, action, {
				success: state => {
					// only update termsConditions if it still matches the current workingEvent
					if (state.workingEvent?.terms_id === action.payload?.terms_id) {
						return { ...state, termsConditions: action.payload };
					} else {
						return state;
					}
				}
			});
		}

		case CLEAR_TERMS_CONDITIONS: {
			return {
				...state,
				termsConditions: null,
			};
		}

		case SET_EDITOR_SIZE: {
			return {
				...state,
				editorSize: action.payload
			};
		}

		case TOGGLE_PREVIEW_MODE: {
			return {
				...state,
				previewMode: action.payload
			};
		}

		case SET_SOCIAL_SHARING: {
			if (!state.workingEvent) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					social_sharing: action.payload
				}
			};
		}

		case GET_PUBLISHED_EVENT_URL: {
			return handle(state, action, {
				start: state => ({
					...state,
					fetchingPublishedStatus: true,
					errorFetchingPublishedStatus: false,
				}),
				success: state => {
					if (action.payload?.status === Status.Published) {
						return {
							...state,
							publishedUrl: action.payload.url,
							errorFetchingPublishedStatus: false,
						};
					} else {
						return {
							...state,
							publishedUrl: '',
							errorFetchingPublishedStatus: false,
						};
					}
				},
				finish: state => ({
					...state,
					fetchingPublishedStatus: false,
				}),
				failure: state => ({
					...state,
					errorFetchingPublishedStatus: true,
				})
			});
		}

		case UPDATE_PUBLISHED_EVENT_URL: {
			return {
				...state,
				publishedUrl: action.payload
			};
		}

		case CLEAR_PUBLISHED_URL: {
			return {
				...state,
				publishedUrl: null
			};
		}

		case UPDATE_EVENT_FAVICON: {
			return handle(state, action, {
				success: state => {
					return {
						...state,
						workingEvent: state?.workingEvent ? {
							...state.workingEvent,
							favicon: action.payload.favicon,
						} : null,
						selectedEvent: state?.selectedEvent ? {
							...state.selectedEvent,
							favicon: action.payload.favicon,
						} : null,
					};
				},
			});
		}

		case DELETE_EVENT_FAVICON: {
			return handle(state, action, {
				success: state => {
					return {
						...state,
						workingEvent: state?.workingEvent ? {
							...state.workingEvent,
							favicon: null,
						} : null,
						selectedEvent: state?.selectedEvent ? {
							...state.selectedEvent,
							favicon: null,
						} : null,
					};
				},
			});
		}

		case UPDATE_CURRENT_POST_REGISTER_PAGE: {
			return {
				...state,
				currentPostRegisterPage: action.payload
			};
		}

		case UPDATE_EMAIL_COLOR: {
			if (!state?.workingEvent) { return state; }
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					settings: {
						...state.workingEvent.settings,
						email: {
							...(state?.workingEvent?.settings?.email || {}),
							colors: action.payload,
						},
					},
				},
			};
		}

		case TOGGLE_EMAIL_SETTINGS_HIDE_BRANDING: {
			if (!state?.workingEvent) { return state; }
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					settings: {
						...state.workingEvent.settings,
						email: {
							...(state?.workingEvent?.settings?.email || {}),
							hideBrandliveLogo: action.payload
						},
					},
				},
			};
		}

		case UPDATE_EVENT_NAVBAR: {
			if (!state.workingEvent) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					settings: {
						...state.workingEvent.settings,
						event_navbar: action.payload
					}
				}
			};
		}

		case TOGGLE_DISPLAY_SESSION_FOOTER: {
			if (!state.workingEvent) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					settings: {
						...state.workingEvent.settings,
						display_session_footer: action.payload
					}
				}
			};
		}

		case TOGGLE_DISPLAY_SESSIONS: {
			if (!state.workingEvent) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					settings: {
						...state.workingEvent.settings,
						display_sessions: action.payload
					}
				}
			};
		}

		case TOGGLE_DISPLAY_LANDING_PAGE: {
			if (!state.workingEvent) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					settings: {
						...state.workingEvent.settings,
						display_landing_page: action.payload
					}
				}
			};
		}

		case TOGGLE_DISPLAY_DIRECTORY: {
			if (!state?.workingEvent?.social_settings) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					social_settings: {
						...state.workingEvent.social_settings,
						directory: {
							...(state.workingEvent.social_settings?.directory || {}),
							isOn: action.payload
						}
					}
				}
			};
		}

		case TOGGLE_DISPLAY_PROFILES: {
			if (!state?.workingEvent?.social_settings) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					social_settings: {
						...state.workingEvent.social_settings,
						profiles: {
							...(state.workingEvent.social_settings?.profiles || {}),
							isOn: action.payload
						}
					}
				}
			};
		}

		case TOGGLE_MESSAGING: {
			if (!state?.workingEvent?.social_settings) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					social_settings: {
						...state.workingEvent.social_settings,
						messaging: action.payload
					}
				}
			};
		}

		case CREATE_EVENT_CHAT_CHANNEL: {
			if (!state?.workingEvent?.social_settings) return state;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					social_settings: {
						...state.workingEvent.social_settings,
						eventChatChannels: state.workingEvent.social_settings.eventChatChannels.concat(action.payload),
					}
				}
			};
		}

		case TOGGLE_TOPIC_GROUP_CHATS: {
			if (!state?.workingEvent?.social_settings) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					social_settings: {
						...state.workingEvent.social_settings,
						topicGroupChats: action.payload
					}
				}
			};
		}

		case TOGGLE_PROFILE_APPEARANCE: {
			if (!state?.workingEvent?.social_settings) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					social_settings: {
						...state.workingEvent.social_settings,
						profiles: {
							...(state.workingEvent.social_settings?.profiles || {}),
							displayType: action.payload
						}
					}
				}
			};
		}

		case TOGGLE_FILTERS: {
			if (!state?.workingEvent?.social_settings) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					social_settings: {
						...state.workingEvent.social_settings,
						directory: {
							...(state.workingEvent.social_settings?.directory || {}),
							allowFilters: action.payload
						}
					}
				}
			};
		}

		case SET_FILTERS: {
			if (!state?.workingEvent?.social_settings) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					social_settings: {
						...state.workingEvent.social_settings,
						directory: {
							...(state.workingEvent.social_settings?.directory || {}),
							filters: action.payload
						}
					}
				}
			};
		}

		case TOGGLE_BOOKMARK_ATTENDEES: {
			if (!state?.workingEvent?.social_settings) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					social_settings: {
						...state.workingEvent.social_settings,
						directory: {
							...(state.workingEvent.social_settings?.directory || {}),
							allowBookmarking: action.payload
						}
					}
				}
			};
		}

		case ADD_CUSTOM_PAGE: {
			if (!state.workingEvent) return state;
			const _workingEvent = { ...state.workingEvent };
			const page: CustomPage = action.payload;

			const custom_pages = _workingEvent.custom_pages
				? [..._workingEvent.custom_pages, page]
				: [page];

			return {
				...state,
				workingEvent: {
					..._workingEvent,
					custom_pages
				}
			};
		}
		case UPDATE_CUSTOM_PAGES: {
			if (!state.workingEvent) return state;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					custom_pages: action.payload
				}
			};
		}
		case UPDATE_CUSTOM_PAGE: {
			if (!state.workingEvent) return state;
			const updatedPage = action.payload;

			const customPages = state.workingEvent.custom_pages?.map(page => {
				if (page.uuid === updatedPage.uuid) return updatedPage;
				else return page;
			});
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					custom_pages: customPages
				}
			};
		}
		case DELETE_CUSTOM_PAGE: {
			return handle(state, action, {
				start: state => ({
					...state,
					errorDeletingCustomPage: false
				}),
				success: state => {
					if (!state.workingEvent) return state;
					const customPages = state.workingEvent.custom_pages?.map(page => {
						if (page.uuid === action.payload.uuid) {
							const deletedpage = {
								...page,
								deleted: true,
							};
							return deletedpage;
						}
						else return page;
					});
					return {
						...state,
						workingEvent: {
							...state.workingEvent,
							custom_pages: customPages,
							errorDeletingCustomPage: false
						}
					};
				},
				failure: state => ({
					...state,
					errorDeletingCustomPage: true
				})
			});
		}
		case TOGGLE_CUSTOM_PAGE_MODULE: {
			if (!state.workingEvent) return state;
			const { pageId, moduleId, is_on } = action.payload;

			const customPages = state.workingEvent.custom_pages?.map(page => {
				if (page.custom_page !== pageId) return page;

				const updatedModules = page.modules?.map(module => {
					if (module.id !== moduleId) return module;
					return {
						...module,
						is_on
					};
				});

				return {
					...page,
					modules: updatedModules
				};
			});

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					custom_pages: customPages
				}
			};
		}
		case UPDATE_CUSTOM_PAGE_MODULE: {
			if (!state.workingEvent) return state;
			const { pageId, updatedModule } = action.payload;

			const customPages = state.workingEvent.custom_pages?.map(page => {
				if (page.custom_page !== pageId) return page;

				const updatedModules = page.modules?.map(module => {
					if (module.id !== updatedModule.id) return module;
					return updatedModule;
				});

				return {
					...page,
					modules: updatedModules
				};
			});

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					custom_pages: customPages
				}
			};
		}
		case SET_ADD_MODULE_MODAL_OPEN: {
			return {
				...state,
				addModuleModalOpen: action.payload
			};
		}
		case SET_SOCIAL_SETTINGS: {
			return handle(state, action, {
				success: state => {
					if (!action.payload?.social_settings) return state;
					return {
						...state,
						workingEvent: state.workingEvent ? {
							...state.workingEvent,
							social_settings: {
								...(state.workingEvent.social_settings || {}),
								...action.payload.social_settings,
							},
						} : null,
					};
				}
			});
		}
		case SET_SOCIAL_IN_STORE_ONLY: {
			if (!state?.workingEvent?.social_settings) return state;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					social_settings: {
						...(state.workingEvent.social_settings || {}),
						...action.payload,
					},
				},
			};
		}

		case TOGGLE_RECAPTCHA: {
			if (!state.workingEvent?.registration_settings) return state;

			return ({
				...state,
				workingEvent: {
					...state.workingEvent,
					registration_settings: {
						...state.workingEvent?.registration_settings,
						enableRecaptcha: action.payload,
					},
				},
			});
		}

		case TOGGLE_PERSONALIZED_ATTENDEE_LIST: {
			if (!state?.workingEvent) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					settings: {
						...state.workingEvent.settings,
						personalizedAttendeeList: action.payload
					}
				}
			};
		}
		case TOGGLE_SHOW_ADD_TO_CAL_BTN: {
			const newWorkingEvent = Object.assign({}, state.workingEvent);
			newWorkingEvent.settings.show_add_to_cal_btn = action.payload;

			return {
				...state,
				workingEvent: newWorkingEvent
			};
		}
		case TOGGLE_DISPLAY_SESSION_LANGUAGE_DROPDOWN: {
			if (!state.workingEvent) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					settings: {
						...state.workingEvent.settings,
						display_session_language_dropdown: action.payload
					}
				}
			};
		}

		case TOGGLE_TRACK_MODAL: {
			if (!state.workingEvent) return state;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					settings: {
						...state.workingEvent.settings,
						personalizedAttendeeListModal: action.payload
					}
				}
			};
		}
		case SET_VOD_ORDER: {
			if (!state?.workingEvent) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					settings: {
						...state.workingEvent.settings,
						vodOrder: action.payload
					}
				}
			};
		}
		case ADMIN_TOGGLE_IN_PERSON_ATTENDEE_MODE: {
			if (!state?.workingEvent?.registration_settings) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					registration_settings: {
						...state.workingEvent.registration_settings,
						adminInPersonAttendeeModeEnabled: action.payload
					}
				}
			};

		}
		case TOGGLE_DISPLAY_LIVE_EVENT_BANNER: {
			if (!state?.workingEvent) return state;
			return {
				...state,
				displayLiveBanner: action.payload
			};
		}

		case TOGGLE_CLOSE_REGISTRATION: {
			if (!state.workingEvent?.registration_settings) return state;

			return ({
				...state,
				workingEvent: {
					...state.workingEvent,
					registration_settings: {
						...state.workingEvent?.registration_settings,
						isClosed: action.payload,
					},
				},
			});
		}

		case FORCE_QUILL_RERENDER: {
			return {
				...state,
				forceQuillRerender: action.payload,
			};
		}

		case GET_EVENT_SCHEDULED_EMAILS: {
			return handle(state, action, {
				start: state => {
					if (!state.workingEvent) return state;
					return {
						...state,
						scheduledEmails: {
							...state.scheduledEmails,
							loadingEmails: true
						}
					};
				},
				success: state => {
					if (!state.workingEvent) return state;
					return {
						...state,
						scheduledEmails: {
							...state.scheduledEmails,
							scheduledEmails: action.payload,
							loadingEmails: false
						}
					};
				},
				finish: state => {
					if (!state.workingEvent) return state;
					return {
						...state,
						scheduledEmails: {
							...state.scheduledEmails,
							loadingEmails: false
						}
					};
				}
			});
		}

		case GET_CHANNEL_SCHEDULED_EMAILS: {
			return handle(state, action, {
				start: state => ({
					...state,
					errorFetchingChannelScheduledEmails: false,
					fetchingChannelScheduledEmails: true,
				}),
				success: state => ({
					...state,
					channelScheduledEmails: action.payload,
				}),
				failure: state => ({
					...state,
					errorFetchingChannelScheduledEmails: true,
				}),
				finish: state => ({
					...state,
					fetchingChannelScheduledEmails: false,
				}),
			});
		}

		case CLEAR_CHANNEL_SCHEDULED_EMAILS: {
			return {
				...state,
				errorFetchingChannelScheduledEmails: false,
				fetchingChannelScheduledEmails: false,
				channelScheduledEmails: [],
			};
		}

		case CREATE_SCHEDULED_EMAIL: {
			return handle(state, action, {
				start: state => {
					if (!state.workingEvent) return state;
					return {
						...state,
						scheduledEmails: {
							...state.scheduledEmails,
							loadingEmails: true
						}
					};
				},
				success: state => {
					if (!state.workingEvent) return state;
					return {
						...state,
						scheduledEmails: {
							...state.scheduledEmails,
							scheduledEmails: [...(state.scheduledEmails?.scheduledEmails ?? []), action.payload],
							displayEmail: action.payload.uuid,
							loadingEmails: false
						}
					};
				},
				finish: state => {
					if (!state.workingEvent) return state;
					return {
						...state,
						scheduledEmails: {
							...state.scheduledEmails,
							loadingEmails: false
						}
					};
				}
			});
		}

		case EDIT_SCHEDULED_EMAIL: {
			return handle(state, action, {
				start: state => {
					if (!state.workingEvent) return state;
					return {
						...state,
						scheduledEmails: {
							...state.scheduledEmails,
							loadingEmails: true
						}
					};
				},
				success: state => {
					if (!state.workingEvent) return state;
					const updatedEmailList = state.scheduledEmails?.scheduledEmails?.map(email => {
						if (email.uuid === action.payload.uuid) return action.payload;
						return email;
					});
					return {
						...state,
						scheduledEmails: {
							...state.scheduledEmails,
							scheduledEmails: updatedEmailList,
							loadingEmails: false
						}
					};
				},
				finish: state => {
					if (!state.workingEvent) return state;
					return {
						...state,
						scheduledEmails: {
							...state.scheduledEmails,
							loadingEmails: false
						}
					};
				}
			});
		}

		case EDIT_SCHEDULED_EMAIL_IN_ADMIN: {
			if (!state.scheduledEmails?.scheduledEmails) return state;
			const editedEmail: IScheduledEmail = action.payload;
			const updatedScheduledEmails = state.scheduledEmails.scheduledEmails.map(email => {
				if (email.uuid === editedEmail.uuid) {
					return editedEmail;
				}
				return email;
			});
			return {
				...state,
				scheduledEmails: {
					...state.scheduledEmails,
					scheduledEmails: updatedScheduledEmails,
				}
			};
		}

		case DELETE_SCHEDULED_EMAIL: {
			return handle(state, action, {
				start: state => {
					if (!state.workingEvent) return state;
					return {
						...state,
						scheduledEmails: {
							...state.scheduledEmails,
							loadingEmails: true
						}
					};
				},
				success: state => {
					if (!state.workingEvent) return state;
					const updatedEmailList = state.scheduledEmails?.scheduledEmails?.filter(schedule => schedule.uuid !== action.payload.uuid);
					return {
						...state,
						scheduledEmails: {
							...state.scheduledEmails,
							scheduledEmails: updatedEmailList,
							loadingEmails: false,
							displayEmail: undefined
						}
					};
				},
				finish: state => {
					if (!state.workingEvent) return state;
					return {
						...state,
						scheduledEmails: {
							...state.scheduledEmails,
							loadingEmails: false
						}
					};
				}
			});
		}

		case SET_DISPLAY_SCHEDULED_EMAIL: {
			if (!state) return state;
			return {
				...state,
				scheduledEmails: {
					...state.scheduledEmails,
					displayEmail: action.payload,
				}
			};
		}

		case CLEAR_SCHEDULED_EMAILS: {
			if (!state) return state;
			return {
				...state,
				scheduledEmails: null
			};
		}

		case TOGGLE_TRANSLATIONS_V2: {
			if (!state.workingEvent) {
				return state;
			} else {
				// if toggling off v2 translations, we need to reset to english for the base language
				const shouldResetEventBaseLanguage = !action.payload;
				return {
					...state,
					workingEvent: {
						...state.workingEvent,
						settings: {
							...state.workingEvent.settings,
							translation_version: action.payload ? 2 : 1,
							i18n: shouldResetEventBaseLanguage ? { base: 'en' } : state.workingEvent.settings?.i18n
						}
					}
				};
			}
		}
		case RE_RENDER_QUILL: {
			return {
				...state,
				reRenderQuillCount: state.reRenderQuillCount + 1
			};
		}
		case SET_TRANSLATION_MANIFESTS: {
			if (!state.workingEvent) {
				return state;
			} else {
				return {
					...state,
					workingEvent: {
						...state.workingEvent,
						translation_manifests: action.payload
					}
				};
			}
		}

		case ADD_EVENT_TEMPLATE: {
			return { ...state, templates: [...(state.templates ?? []), action.payload] };
		}

		case UPDATE_EVENT_TEMPLATE: {
			return {
				...state,
				templates: (state.templates ?? [])?.map(template => {
					if (template.template === action.payload.template) {
						return action.payload;
					}
					return template;
				})
			};
		}

		case REMOVE_CUSTOM_TEMPLATES: {
			const templatesToDelete = action.payload as number[];
			return {
				...state,
				templates: (state.templates ?? [])?.filter(template => {
					if (templatesToDelete.includes(template.template)) {
						return false;
					}
					return true;
				})
			};
		}

		case SETUP_EVENT_PREVIEW: {
			return handle(state, action, {
				start: state => ({
					...state,
					settingUpEventPreview: true
				}),
				success: state => {
					if (!state.workingEvent) {
						return state;
					}

					return {
						...state,
						settingUpEventPreview: false,
						workingEvent: {
							...state.workingEvent,
							event_preview: action.payload
						}
					};
				}
			});
		}

		case UPDATE_EVENT_PREVIEW_PASSWORD: {
			return handle(state, action, {
				start: state => ({
					...state,
					updatingEventPreviewPassword: true
				}),
				success: state => {
					if (!state.workingEvent?.event_preview) {
						return state;
					}

					return {
						...state,
						updatingEventPreviewPassword: false,
						workingEvent: {
							...state.workingEvent,
							event_preview: {
								...state.workingEvent.event_preview,
								password: action.payload.password
							}
						}
					};
				}
			});
		}

		case UPDATE_SESSION_FEEDBACK_SURVEY_TEXT: {
			if (!state.workingEvent) return state;
			return handle(state, action, {
				success: state => {
					if (!state.workingEvent) return state;
					return {
						...state,
						workingEvent: {
							...state.workingEvent,
							settings: {
								...state.workingEvent?.settings,
								feedback_survey_text: action.payload
							}
						}
					};
				}
			});
		}

		case PUBLISH_EVENT_PREVIEW: {
			return handle(state, action, {
				start: state => ({
					...state,
					publishingEventPreview: true
				}),
				success: state => {
					return {
						...state,
						publishingEventPreview: false,
					};
				}
			});
		}

		case SET_EVENT_TAGS: {
			if (!state.workingEvent) return state;

			const tags = action.payload as IEventTag[];
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					tags,
				},
			};
		}

		case TOGGLE_AUTOMATIC_SESSION_FILTER_BY_USER_LANGUAGE: {
			if (!state.workingEvent) {
				return state;
			} else {
				return {
					...state,
					workingEvent: {
						...state.workingEvent,
						automatic_session_filter_by_user_language: action.payload
					}
				};
			}
		}

		case UPDATE_CHANNEL_ICON: {
			if (!state.workingEvent) return state;
			else {
				return {
					...state,
					channelIcons: action.payload
				};
			}
		}

		case SET_EMAIL_LINK_LIMIT: {
			if (!state.workingEvent?.registration_settings) return state;

			return ({
				...state,
				workingEvent: {
					...state.workingEvent,
					registration_settings: {
						...state.workingEvent?.registration_settings,
						emailLinkLimit: action.payload,
					},
				},
			});
		}

		case UPDATE_SESSION_BACKUP_URL: {
			if (!state.selectedEvent) {
				return state;
			} else {
				const { sessionUuid, enabled, url } = action.payload;
				const newSessions = [...state.selectedEvent.sessions];

				newSessions.forEach((session: Session) => {
					if (session.uuid === sessionUuid) {
						session.backup_url_enabled = enabled;
						session.backup_url = url;
					}
				});

				return {
					...state,
					selectedEvent: {
						...state.selectedEvent,
						sessions: newSessions
					}
				};
			}
		}

		case SET_ACTIVE_ACCORDION_CONTAINER: {
			return {
				...state,
				accordion: {
					...state.accordion,
					focusedContainer: action.payload,
				}
			};
		}

		case ADD_LEADERBOARD_NAV_ITEM: {
			return handle(state, action, {
				success: state => {
					if (!state?.workingEvent?.homepage?.event_main_nav_items) return state;
					if (!action.payload) return state;
					return {
						...state,
						workingEvent: {
							...state.workingEvent,
							homepage: {
								...state.workingEvent.homepage,
								event_main_nav_items: [
									...state.workingEvent.homepage.event_main_nav_items,
									action.payload
								],
							}
						}
					};
				},
			});
		}

		case SET_MARKETING_OPT_IN_TYPE: {
			if (!state.workingEvent?.registration_settings) return state;

			return ({
				...state,
				workingEvent: {
					...state.workingEvent,
					registration_settings: {
						...state.workingEvent.registration_settings,
						marketing_email_options: action.payload,
					},
				},
			});
		}

		case GET_TEMPLATE_EVENTS: {
			return handle(state, action, {
				start: state => ({
					...state,
					templateEvents: {
						...state.templateEvents,
						loadingStatus: LoadingStatus.Loading,
						error: null,
					}
				}),
				success: state => ({
					...state,
					templateEvents: {
						...state.templateEvents,
						templateEvents: action.payload.events,
						totalTemplates: action.payload?.totals?.total_template_events,
						error: null,
					}
				}),
				failure: state => {
					return {
						...state,
						templateEvents: {
							...state.templateEvents,
							error: action.payload,
						}
					};
				},
				finish: state => ({
					...state,
					templateEvents: {
						...state.templateEvents,
						loadingStatus: LoadingStatus.Done,
					}
				}),
			});
		}

		case CREATE_TEMPLATE_EVENT: {
			return handle(state, action, {
				start: state => ({
					...state,
					templateEvents: {
						...state.templateEvents,
						loading: true,
						error: null,
					}
				}),
				success: state => {
					// if template is already there, remove to replace with updated
					const filteredTemplateEvents = state.templateEvents.templateEvents.filter(template => template.uuid !== action.payload.uuid);
					return {
						...state,
						templateEvents: {
							...state.templateEvents,
							templateEvents: [...filteredTemplateEvents, action.payload]
						}
					};
				},
				failure: state => ({
					...state,
					templateEvents: {
						...state.templateEvents,
						error: action.payload.message
					}
				}),
				finish: state => ({
					...state,
					templateEvents: {
						...state.templateEvents,
						loading: false
					}
				}),
			});
		}

		case CLEAR_TEMPLATE_EVENTS_ERROR: {
			return {
				...state,
				templateEvents: {
					...state.templateEvents,
					error: null,
				}
			};
		}

		case RESET_TEMPLATE_EVENTS: {
			return {
				...state,
				templateEvents: initialState.templateEvents,
			};
		}

		case RESET_FETCH_EVENT_LOADING_STATUS: {
			return {
				...state,
				templateEvents: {
					...state.templateEvents,
					loadingStatus: LoadingStatus.PreLoading,
				}
			};
		}

		case UPDATE_SESSION_TITLE_AND_TRACKS: {
			return handle(state, action, {
				start: state => ({
					...state,
				}),
				success: state => {
					if (!state.workingEvent?.sessions) return state;
					return {
						...state,
						workingSession: !state.workingSession ? state.workingSession : {
							...state.workingSession,
							tracks: action.payload[state.workingSession.uuid].tracks,
						},
						workingEvent: {
							...state.workingEvent,
							sessions: state.workingEvent?.sessions?.map(session => {
								if (action.payload[session.uuid]) {
									return {
										...session,
										tracks: action.payload[session.uuid].tracks,
									};
								}
								return session;
							}),
						},
					};
				},
				finish: state => ({
					...state,
				}),
			});
		}

		default: return state;
	}
}

const SAVING_ACTION = [
	ADD_REGISTRATION_REQUIREMENT,
	ADD_NEW_SESSION,
	UPDATE_SESSION_INFO,
	UPDATE_SESSION_CARD,
	SET_REGISTRATION_HEADER,
	SET_REGISTRATION_DESCRIPTION,
	SET_REGISTRATION_IMAGE,
	SET_REGISTRATION_LOGO,
	SET_REGISTRATION_ON,
	SET_REGISTRATION_TYPE,
	SET_REGISTRATION_FEATURE,
	SET_REGISTRATION_SINGLE_SIGN_ON,
	SET_REGISTRATION_SINGLE_SIGN_ON_TYPES,
	SET_REGISTRATION_SSO_DISPLAY_TOP,
	SET_REGISTRATION_QUESTIONS,
	UPDATE_REGISTRATION_STEPS,
	SET_SELECTED_FONT,
	SET_SELECTED_COLOR,
	SET_DESIGN_SHAPE,
	SET_DESIGN_STYLE,
	SET_CUSTOM_CSS,
	SET_DESIGN_COLORS,
	UPDATE_HOMEPAGE_MODULE,
	UPDATE_HOMEPAGE_FOOTER,
	UPDATE_HOMEPAGE_HEADER,
	UPDATE_HOMEPAGE_MAIN_NAV,
	UPDATE_HOMEPAGE_PROFILE_NAV,
	SET_HOMEPAGE_MODULES,
	ADD_PAGE_MODULE,
	TOGGLE_AUTOMATIC_SESSION_FILTER_BY_USER_LANGUAGE,
	TOGGLE_POST_REGISTER_HOME_MODULE,
	SET_BLOCKED_DOMAIN_EMAILS,
	REMOVE_REGISTRATION_REQUIREMENT,
	UPDATE_REGISTRATION_REQUIREMENT,
	UPDATE_TICKETING_SET,
	ADD_TICKETING_SET,
	REMOVE_TICKETING_SET,
	SET_EVENT_CUSTOM_CSS,
	SET_EVENT_CUSTOM_COMPILED_CSS,
	UPDATE_REQUIRED_REGISTRATION_QUESTIONS,
	SET_SOCIAL_SHARING,
	UPDATE_EMAIL_COLOR,
	TOGGLE_EMAIL_SETTINGS_HIDE_BRANDING,
	SAVE_COLOR_PACK,
	UPDATE_EVENT_NAVBAR,
	TOGGLE_DISPLAY_SESSION_FOOTER,
	TOGGLE_DISPLAY_SESSIONS,
	TOGGLE_DISPLAY_LANDING_PAGE,
	ADD_CUSTOM_PAGE,
	UPDATE_CUSTOM_PAGES,
	UPDATE_CUSTOM_PAGE,
	DELETE_CUSTOM_PAGE,
	TOGGLE_DISPLAY_DIRECTORY,
	TOGGLE_DISPLAY_PROFILES,
	TOGGLE_MESSAGING,
	TOGGLE_BOOKMARK_ATTENDEES,
	TOGGLE_PROFILE_APPEARANCE,
	TOGGLE_FILTERS,
	TOGGLE_TOPIC_GROUP_CHATS,
	SET_FILTERS,
	SET_CUSTOM_PASSCODE_LABEL,
	SET_REJECTED_PASSCODE_MESSAGE,
	CREATE_EVENT_CHAT_CHANNEL,
	TOGGLE_RECAPTCHA,
	TOGGLE_PERSONALIZED_ATTENDEE_LIST,
	TOGGLE_SHOW_ADD_TO_CAL_BTN,
	TOGGLE_TRACK_MODAL,
	SET_VOD_ORDER,
	TOGGLE_CLOSE_REGISTRATION,
	ADMIN_TOGGLE_IN_PERSON_ATTENDEE_MODE,
	TOGGLE_TRANSLATIONS_V2,
	SET_EVENT_TAGS,
	TOGGLE_DISPLAY_SESSION_LANGUAGE_DROPDOWN,
	SET_EMAIL_LINK_LIMIT,
	UPDATE_SESSION_BACKUP_URL,
	SET_MARKETING_OPT_IN_TYPE,
];

const REFETCHING_ACTION = [
	ADD_NEW_SESSION,
	UPDATE_SESSION_INFO,
];

export default function CreateEventReducer(state: CreateEventState = initialState, action: Action): CreateEventState {
	const newState = getState(state, action);


	if (SAVING_ACTION.includes(action.type)) {
		// clearTimeout must go inside the if statement, otherwise it can be accidentally cancelled
		clearTimeout(timeout);
		timeout = setTimeout(async () => {
			// eslint-disable-next-line @typescript-eslint/no-var-requires
			const store = require('../../main');

			if (store.default) {
				const {
					CreateEventReducer: {
						workingEvent
					},
					AuthReducer: {
						token
					}
				} = store.default.getState();

				if (workingEvent) {
					store.default.dispatch(isSavingEvent(true));

					const _workingEvent: BrandliveEvent = workingEvent;
					_workingEvent.status = 2;
					const result = await SaveEvent(_workingEvent, token);

					// this fixes issue where homepage translations do not update in redux when a new item is added into a modules
					if (result?.homepage?.modules && _workingEvent?.homepage?.modules) {
						_workingEvent.homepage.modules = result.homepage.modules;
						store.default.dispatch(resetHomepageModules(result.homepage.modules));
					}

					// update events reducer so published status gets updated
					store.default.dispatch(updateAdminEvents(_workingEvent));

					if (REFETCHING_ACTION.includes(action.type)) {
						store.default.dispatch(loadWorkingEvent(_workingEvent.uuid, token));
					}
					store.default.dispatch(isSavingEvent(false));
				}
			}
		}, 1000);
	}
	return newState;
}
